// referral.js - Auto apply discount codes based on advocate referral token.
(function() {
  try {
    // Skip referral logic on checkout pages (including checkout recovery URLs)
    if (window.location.pathname.includes('/checkouts/')) {
      return;
    }

    // Detect referral token – support both the new `?r=<token>` query param and the legacy `/r/<token>` path.
    var urlParams = new URLSearchParams(window.location.search);
    var token = urlParams.get('r');

    // NEW: Capture encoded email from the URL and record invite link click
    var email = urlParams.get('email');
    if (email) {
      try {
        // Decode Base64 (including URL-safe flavor) email string
        function decodeBase64Email(str) {
          var cleaned = str.replace(/-/g, '+').replace(/_/g, '/');
          while (cleaned.length % 4 !== 0) cleaned += '='; // pad for proper length
          var decoded = atob(cleaned);
          return decoded;
        }

        var emailParam = decodeBase64Email(email.trim());
        // Fire-and-forget API request – should not block any UI/redirect logic
        fetch('https://api.wildgrain.com/api/referrals/invite/clicked', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: emailParam })
        }).catch(function(err) {
          console.warn('Failed to record invite link click', err);
        });

      } catch (emailDecodeErr) {
        console.warn('Failed to decode email parameter', emailDecodeErr);
      }
    }

    if (!token) {
      var match = window.location.pathname.match(/^\/r\/([A-Za-z0-9_-]+)\/?$/);
      if (match) token = match[1];
    }

    if (!token) return; // Not a referral URL

    // ---------------------------------------------------------------------------
    // Early-exit: If the visitor already has a Wildgrain referral discount code
    // stored (codes always start with "FR-"), we don't need to request another
    // one for 7 days (cookie TTL is set to 7 days when originally issued).
    // ---------------------------------------------------------------------------

    // Helper to read a cookie value
    function getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
      }
      return null;
    }

    var cachedCode = getCookie('wg_discount_code');
    var hasSeenDrawer = getCookie('wg_referral_drawer_seen');

    if (cachedCode && cachedCode.indexOf('FR-') === 0 && hasSeenDrawer) {
      // We already have a recent referral code AND user has seen the drawer – skip the API call entirely.

      // Build redirect path to ensure the discount is re-applied in case the
      // visitor cleared their cart or is beginning a fresh session.
      var redirectUrl = '/discount/' + encodeURIComponent(cachedCode) + '?redirect=' + encodeURIComponent('/');

      // Directly send them to the discount URL instead of showing the capture
      // modal again – their details were already collected previously.
      window.location.replace(redirectUrl);
      return; // Stop further execution of the referral script
    }

    // If we have a cached code but haven't seen the drawer, treat as first visit
    if (cachedCode && cachedCode.indexOf('FR-') === 0 && !hasSeenDrawer) {
      // Continue to show the drawer with the cached code
      var redirectUrl = '/discount/' + encodeURIComponent(cachedCode) + '?redirect=' + encodeURIComponent('/');
      window.showReferralDrawer(null, cachedCode, redirectUrl);
      return;
    }


    // Fetch a fresh discount code from Wildgrain API
    fetch('https://api.wildgrain.com/api/referrals/discount-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      // `c` = campaign the link was shared under (absent on older links)
      body: JSON.stringify({ token: token, campaign: urlParams.get('c') || undefined })
    })
      .then(function(res) {
        if (!res.ok) throw res; // Will be caught below
        return res.json();
      })
      .then(function(data) {
        if (data && data.code) {
          var isFriendOffer = data.converted_to === 'friend_offer';

          // Friend-offer codes redirect to the bundle builder; credit codes go to homepage
          var redirectPath = isFriendOffer
            ? '/products/custom-wildgrain-box?selectedSize=6+items&friend_offer=true'
            : '/' + (data.advocate_name ? '?advocate=' + encodeURIComponent(data.advocate_name) : '');

          var redirectUrl = '/discount/' + encodeURIComponent(data.code) + '?redirect=' + encodeURIComponent(redirectPath);

          var discountData = {
            code: data.code,
            amount: data.amount || data.discount_amount || data.discountAmount || data.value || null,
            qty: data.qty || data.discount_qty || data.discountQty || 1
          };

          if (isFriendOffer) {
            try { sessionStorage.setItem('wg_friend_offer', 'true'); } catch (e) {}
          }

          var drawerOptions = { conversionMessage: data.message || null };
          if (isFriendOffer) {
            drawerOptions.title = data.advocate_name ? data.advocate_name + ' sent you a free Wildgrain box!' : 'You got a free Wildgrain box!';
            drawerOptions.subtitle = 'Enter your details below to claim your free 6-item box. You only pay $15 shipping.';
          }

          window.showReferralDrawer(data.advocate_name, data.code, redirectUrl, discountData, drawerOptions);
        } else {
          // No code field present – fallback
          window.location.replace('/');
        }
      })
      .catch(function(err) {
        // On 400/404 or network errors, just send visitor to homepage
        console.error('Referral discount lookup failed', err);
        window.location.replace('/');
      });
  } catch (e) {
    console.error('Referral script error', e);
  }
})();
